<template>
  <div>
    <InvoiceViewer ref="invoiceViewer" />

    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      style="overflow: visible; z-index: 300">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="isOpen" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-6">
          <div class="titlePanel primary--text">
            {{ $t('expenses.registerMovements.payOrders.drawerDetails.title') }} {{ payOrder.uuid }}
          </div>
        </div>
        <div v-if="payOrder" class="d-flex mt-10 mx-7 flex-column" style="height: 100%;">
          <div class="d-flex justify-space-between">
            <div class="d-flex invoiceBlankBox">
              <table>
                <tr>
                  <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.supplier') }}</td>
                  <!-- <td>{{ invoice.data ? invoice.data.source : undefined }}</td> -->
                  <td>
                    <!-- {{ !isEmpty(payOrder.invoices) && payOrder.invoices[0]
                      ? payOrder.invoice[0].source
                      : payOrder.provider
                        ? findSupplierName(payOrder.provider)
                        : undefined
                    }} -->
                    {{ payOrder.providerName ? payOrder.providerName : '-'}}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.author') }}</td>
                  <td>{{ payOrder.author ? payOrder.author.email :  '-' }} </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.status') }}</td>
                  <td>{{ STATUS_TYPES[payOrder.status] }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.creationDate') }}</td>
                  <td>{{ $moment(payOrder.createdAt).format('DD/MM/YYYY') }}</td>
                </tr>
              </table>
            </div>
            <div class="d-flex invoiceBox">
                <table>
                  <tr>
                    <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.subtotal') }}</td>
                    <td>${{ payOrder.amount | toFix2 | numberWithComma }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.taxes') }}</td>
                    <td>${{ payOrder.tax | toFix2 | numberWithComma }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('expenses.registerMovements.payOrders.drawerDetails.total') }}</td>
                    <td>${{ payOrder.total | toFix2 | numberWithComma }}</td>
                  </tr>
                </table>
            </div>
          </div>
          <div class="mt-10 mb-4 font-weight-bold concept">
            <p>{{ $t('expenses.registerMovements.payOrders.drawerDetails.paymentConcept') }}</p>
          </div>
          <v-data-table
            :loading-text="tableConcepts.title"
            :loading="tableConcepts.loading"
            :headers="tableConcepts.headers"
            :items="tableConcepts.data"
            :footer-props="{
              'items-per-page-options': [5, 10, 15]
            }"
            class="tableConcepts">
            <template v-slot:[`item.quantity`]="{ item }">
              <div>
                <span>
                  {{ item.quantity }}
                </span>
              </div>
            </template>
            <!-- Todo: solve matching between satws units and DB units -->
            <!-- <template v-slot:[`item.unit`]="{ item }">
              <div>
                <span>
                  {{ item.unit }}
                </span>
              </div>
            </template> -->
            <template v-slot:[`item.name`]="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:[`item.category`]="{ item }">
              <div>
                <span>
                  {{ item.cashflow.name ? item.cashflow.name : '-' }}
                </span>
              </div>
            </template>
            <template v-slot:[`item.unitPrice`]="{ item }">
              <div>
                <span>
                  ${{ item.unitPrice | toFix2 | numberWithComma }}
                </span>
              </div>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <div>
                <span>
                  ${{ item.total | toFix2 | numberWithComma }}
                </span>
              </div>
            </template>
            <template v-slot:[`item.discount`]="{ item }">
              <div>
                <span>
                  ${{ item.discount | toFix2 | numberWithComma }}
                </span>
              </div>
            </template>
            <template v-slot:[`item.provider`]="{ item }">
              <div>
                <span>
                  {{ invoice.data ? invoice.data.source : '-' }}
                </span>
              </div>
            </template>
          </v-data-table>
          <div class="d-flex justify-start">
            <div class="mr-3" v-if="invoice.data && invoice.data._id">
              <a @click="openInvoiceViewer()" class="invoiceLink">{{ $t('expenses.registerMovements.payOrders.drawerDetails.invoiceLink') }}</a>
            </div>
            <div v-if="payOrder.file">
              <v-btn
                class="white--text"
                color="info"
                rounded
                depressed
                tag="a"
                target="_blank"
                :href="openDocumentViewer(item)">
                {{ $t('expenses.registerMovements.payOrders.drawerDetails.documentLink') }}
              </v-btn>
            </div>
          </div>
          <div class="grow"></div>
          <div class="d-flex justify-end buttonContainer">
            <v-btn
              v-if="uploadXML"
              color="primary"
              class="mr-2"
              rounded
              depressed
              @click="openUploadXML">
              Adjuntar factura
            </v-btn>
            <v-btn
              v-if="uploadXML"
              color="primary"
              class="mr-2"
              rounded
              depressed
              @click="openRelateInvoiceSatws">
              Buscar factura
            </v-btn>
            <v-btn
              v-if="uploadXML"
              color="secondary"
              class="mr-2"
              rounded
              depressed
              @click="openAttachDialog">
              {{ $t('expenses.registerMovements.payOrders.drawerDetails.buttonAttachDocument') }}
            </v-btn>
            <v-btn
              color="error"
              rounded
              depressed
              @click="closePanel">
              {{ $t('expenses.registerMovements.payOrders.drawerDetails.buttonClose') }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <attach-dialog
      :dialog="attachDialog"
      :orders="orders"
      @close="closeAttachDialog()">
    </attach-dialog>

    <UploadXML ref="uploadXMLDialog" :orders="orderId" @refresh="refreshPayOrdersList"/>
    <RelateInvoiceSatws ref="relateInvoiceSatws" :orders="orderId" @refresh="refreshPayOrdersList"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import attachDialog from '@/components/modals/AttachDocument'
import { isEmpty } from 'lodash'
import UploadXML from '@/components/modals/UploadXML'
import RelateInvoiceSatws from '@/components/modals/RelateInvoiceSatws'

export default {
  name: 'PayOrderDetails',
  props: {
    isOpen: Boolean,
    selectedPayOrder: Object,
    uploadXML: Boolean
  },
  components: {
    InvoiceViewer,
    attachDialog,
    UploadXML,
    RelateInvoiceSatws
  },
  emits: ['close', 'update:isOpen'],
  data () {
    return {
      overlay: false,
      attachDialog: false,
      removeDialog: false,
      tableConcepts: {
        title: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.headers.quantity'), value: 'quantity', sortable: false },
          // { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.headers.unit'), value: 'unit', sortable: false }, // Todo: solve matching between satws units and DB units
          { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.headers.concept'), value: 'name', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.headers.category'), value: 'category', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.headers.cost'), value: 'unitPrice', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.headers.amount'), value: 'total', sortable: false }
          // { text: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.supplier'), value: 'provider', sortable: false }
        ],
        data: [],
        total: 0,
        itemsPerPage: 10,
        page: 1,
        selected: []
      },
      invoice: {
        data: [],
        loading: false
      },
      invoiceFile: '',
      payOrder: {},
      STATUS_TYPES: {
        created: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.statusTypes.created'),
        pending_payment: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.statusTypes.pendingPayment'),
        paid: this.$i18n.t('expenses.registerMovements.payOrders.drawerDetails.statusTypes.paid')
      },
      assignedCategories: {
        data: [],
        loading: false
      },
      categories: {
        data: [],
        loading: true
      },
      suppliers: {
        data: [],
        loading: true
      },
      orderId: [],
      orders: []
    }
  },
  watch: {
    selectedPayOrder: async function () {
      if (this.selectedPayOrder) {
        this.tableConcepts.data = this.selectedPayOrder.concepts
        this.payOrder = this.selectedPayOrder
        this.orders.push(this.selectedPayOrder)
        !isEmpty(this.selectedPayOrder.invoice) ? await this.loadInvoice() : this.invoice.data = {}
        // this.loadAssignedCategories()
      }
    },
    // 'invoice.data': function () {
    //   !isEmpty(this.invoice.data) ? this.loadAssignedCategories() : this.assignedCategories.data = []
    // },
    open: async function (val) {
      if (val) {
        await this.loadSuppliers()
        // await this.loadCategories()
      }
    }
  },
  computed: {
    restaurantTaxid () {
      return this.$store.state.currentRestaurant.taxInformation.data.taxId || ''
    },
    open: {
      get: function () {
        return this.isOpen
      },
      set: function (newValue) {
        this.$emit('update:isOpen', newValue)
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.resetForm()
        this.open = false
        this.$emit('close')
      }
    },
    openDocumentViewer () {
      let url = `${process.env.VUE_APP_API_URL}/v1/expenses/${this.$store.state.currentRestaurant.data._id}/detail-document/${this.payOrder._id}`
      url += `?access_token=${this.$store.state.login.token}`
      return url
    },
    openAttachDialog () {
      this.attachDialog = true
    },
    async closeAttachDialog () {
      this.attachDialog = false
      this.open = false
      this.$emit('updatePayOrders')
    },
    async loadInvoice (params = null) {
      params = params || {}
      this.invoice.loading = true
      try {
        const response = await this.$api.get(`/v1/invoices/${this.selectedPayOrder.invoice._id || this.selectedPayOrder.invoice}`, params)
        this.invoice.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.invoice.loading = false
    },
    resetForm () {
      this.tableConcepts.data = []
      this.tableConcepts.selected = []
    },
    closePanel () {
      this.resetForm()
      this.open = false
      this.$emit('close')
    },
    openInvoiceViewer () {
      this.$refs.invoiceViewer.open(this.invoice.data)
    },
    findSupplierName (supplierId) {
      const supplier = this.suppliers.data.find(supplier => supplier._id === supplierId)
      return isEmpty(supplier) ? undefined : supplier.name
    },
    isEmpty,
    loadSuppliers: async function () {
      const params = {}
      this.suppliers.loading = true
      try {
        const response = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/providers`, params)
        this.suppliers.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.suppliers.loading = false
    },
    openUploadXML () {
      this.orderId.push(this.selectedPayOrder)
      this.$refs.uploadXMLDialog.open()
    },
    openRelateInvoiceSatws () {
      this.orderId.push(this.selectedPayOrder)
      this.$refs.relateInvoiceSatws.open()
    },
    refreshPayOrdersList () {
      this.open = false
      this.$emit('updatePayOrders')
    }
  }
}
</script>

<style lang="scss">
  .content {
    overflow: visible;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .titlePanel {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }

  .subtitle {
    padding-top: 40px;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #646464;
  }

  .tableConcepts .v-data-table td:last-child {
    border-right: 1px solid #ACABAB;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  .tableConcepts tr {
    border: 1px solid #ACABAB;
    border-radius: 7px;
  }

  .tableConcepts td:first-child {
    border-left: 1px solid #ACABAB;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  .tableConcepts td {
    border-top: 1px solid #ACABAB;
    border-bottom: 1px solid #ACABAB;
  }

  .tableConcepts td:last-child {
    border-right: 1px solid #ACABAB;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  .tableConcepts thead tr:last-child th {
    border-bottom: none !important;
  }

  .tableConcepts .v-data-footer {
    border-top: none !important;
  }

  .noInfo {
    border: 1px solid #ACABAB;
    border-radius: 7px;
    padding-top: 22px;
    padding-bottom: 22px;
    text-align: center;
    line-height: 19px;
    color: #ACABAB;
  }

  .theme--light.v-icon {
    color: inherit;
  }

  .grow {
    flex-grow: 1
  }

  .buttonContainer {
    margin-bottom: 80px;
  }

  .invoiceBlankBox {
    table tr td:last-child {
      padding-left: 3rem;
    }
  }

  .invoiceBox {
    padding: 0.875rem 2.313rem;
    background: #F0F0F0;
    border: 1.5px dashed #757575;

    table tr td:last-child {
      padding-left: 3rem;
    }
  }

  .invoiceLink {
    text-decoration: underline;
  }

  .concept {
    font-size: 1.125rem;
  }

</style>
